export const ADMINPAGE = () => `/admin`;
